import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { LinkComponent } from '../../../dashboard/common/html/LinkComponent'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { VALUE_SCORE } from '../constant'
import { ChartTable } from './ChartTable'
import { getIdsTable, getIdsTablePer } from './store/slice'

export const BoxItem = ({
  text,
  keyIds,
  getDataRedux,
  isDynamicReport,
  typeValue,
  isShowNoData,
}) => {
  const idsRisk = useSelector(getIdsTable(keyIds))
  const idsPer = useSelector(getIdsTablePer(keyIds))

  const ids = typeValue === VALUE_SCORE.CREDIT_SCORE ? idsRisk : idsPer

  if (!ids.length && isDynamicReport) {
    return (
      <Notification
        isDynamicReport
        style={!isShowNoData ? { height: 1, width: 1, opacity: 0 } : {}}
      />
    )
  }

  return (
    <div className="wh100 flexColumn">
      <Element
        className="fw600"
        style={{
          color: '#191D25',
          fontSize: 14,
          padding: '2px 0',
        }}
      >
        <Translate value={text.title} />
      </Element>
      <Element className="fstItalic">
        <Translate value={text.textNote} />
      </Element>
      <div className="flex1">
        <Table
          ids={ids}
          getDataFromRedux={getDataRedux}
          isDisplayScroll={false}
          isDynamicReport={isDynamicReport}
          isNoStickyHead={isDynamicReport}
          schema={[
            {
              colId: 'rank',
              title: '#',
              render: (val) => {
                return <div className="dFlex alignItemsCenter gap1">{val}</div>
              },
            },
            {
              colId: 'company',
              title: 'alerts.COMPANY',
              isI18n: true,
              tdStyle: { width: '100%' },
              render: (data) => {
                if (isDynamicReport) {
                  return (
                    <div>
                      <div>{data?.name}</div>
                      <Element className="dFlex">
                        <Translate value="cartAndOrders.orderInformation.taxCode" />
                        :&nbsp;
                        <div>{formatText(data?.taxCode)}</div>
                      </Element>
                    </div>
                  )
                }
                return (
                  <div>
                    <LinkComponent
                      href={
                        data?.organizationId
                          ? `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${data?.organizationId}`
                          : '#'
                      }
                      style={{ color: data?.organizationId && '#2C73E8' }}
                    >
                      <TextEllipsisStaticLine
                        text={formatText(data?.name)}
                        isI18n={false}
                        lineClamp={2}
                      />
                    </LinkComponent>
                    <Element className="dFlex">
                      <Translate
                        value="cartAndOrders.orderInformation.taxCode"
                        className="whiteSpaceNowrap"
                      />
                      :&nbsp;
                      <TextEllipsisStaticLine
                        text={formatText(data?.taxCode)}
                        isI18n={false}
                        lineClamp={1}
                      />
                    </Element>
                  </div>
                )
              },
            },
            {
              colId: 'score',
              title: 'alerts.SCORE',
              isI18n: true,
              tdStyle: { textAlign: 'right' },
              render: (val) => {
                return <div> {formatText(val)}</div>
              },
            },
            {
              colId: 'chart',
              title: 'portfolioScore.trendLine',
              isI18n: true,
              tdStyle: {},
              render: (data) => {
                return (
                  <div style={{ minWidth: 50 }}>
                    <ChartTable data={data} />
                  </div>
                )
              },
            },
          ]}
        />
      </div>
    </div>
  )
}
